import { SyntheticEvent } from "react"
import {
  Block,
  Button,
  ButtonProps,
  ListItem,
  ListItemLabel,
  useStyletron,
} from "@mezo-org/mezo-clay"

import { convertToSnakeCase } from "#/shared/utils"

type MezoAppsItemProps = {
  title: string
  description: string
  image: string
  buttonProps: ButtonProps
  onClick?: (e: SyntheticEvent<HTMLButtonElement, Event>) => void
}

export default function MezoAppsItem({
  title,
  description,
  image,
  buttonProps,
  onClick,
}: MezoAppsItemProps) {
  const [css, theme] = useStyletron()

  return (
    <ListItem
      artwork={() => (
        <Block
          as="img"
          src={image}
          className={css({
            width: theme.sizing.scale1600,
            height: theme.sizing.scale1600,
            objectFit: "cover",
            borderRadius: theme.borders.radius400,
          })}
        />
      )}
      endEnhancer={() => (
        <Button
          shape="pill"
          kind="secondary"
          size="small"
          onClick={onClick}
          {...buttonProps}
        >
          Explore
        </Button>
      )}
      overrides={{
        Root: {
          style: () => ({
            borderRadius: theme.borders.radius300,
            height: "96px",
            width: "100%",
          }),
          props: {
            "data-attr": `${convertToSnakeCase(title)}-apps_on_mezo`,
          },
        },
        Content: {
          style: () => ({
            paddingTop: theme.sizing.scale200,
            paddingBottom: theme.sizing.scale200,
            border: "none",
          }),
        },
        ArtworkContainer: { style: () => ({ width: "96px" }) },
        EndEnhancerContainer: {
          style: () => ({ marginLeft: theme.sizing.scale500 }),
        },
      }}
    >
      <ListItemLabel description={description}>{title}</ListItemLabel>
    </ListItem>
  )
}
